import axios from 'axios'
import {
  get_ts,
  b64encode,
} from '../utils/way'
import qs from 'qs'
const debug = false
axios.defaults.timeout = 100000
if (debug) {
  axios.defaults.baseURL = "http://127.0.0.1:6500"
} else {
  axios.defaults.baseURL = "https://console.metrovpn.xyz"
}
const baseUrl = axios.defaults.baseURL
axios.interceptors.request.use(config => {
  // console.log(config.url)
  // console.log(config.baseURL)
  if (config.url.indexOf("/pay/web/gift_time/") == 0 || config.url.indexOf("/pay/web/win_back/") == 0) {
    if (debug) {
      config.baseURL = "https://dev.metrovpn.xyz"
    } else {
      config.baseURL = "https://app.metrovpn.xyz"
    }
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 
      'se-ua': 'web',
      'ts': get_ts()
  }
  }
  const token = get_token()
  if (token) {
    config.url = config.url + "?token=" + token
  }
  return config
}, error => {
  return Promise.error(error)
})

// 添加响应拦截器，处理arraybuffer响应中的JSON错误
axios.interceptors.response.use(
  response => {
    // 检查是否为arraybuffer响应
    if (response.config.responseType === 'arraybuffer' && response.data) {
      // 检查Content-Type
      const contentType = response.headers['content-type'] || ''
      
      // 如果不是Excel文件类型，尝试解析为JSON
      if (!contentType.includes('application/vnd.openxmlformats') && 
          !contentType.includes('application/octet-stream')) {
        try {
          // 尝试将arraybuffer转换为字符串并解析为JSON
          const decoder = new TextDecoder('utf-8')
          const text = decoder.decode(response.data)
          const jsonData = JSON.parse(text)
          
          // 如果成功解析为JSON，返回JSON数据
          response.data = jsonData
        } catch (e) {
          // 如果解析失败，保持原始arraybuffer数据
          console.log('无法解析为JSON，保持原始arraybuffer数据')
        }
      }
    }
    return response
  },
  error => {
    // 处理错误响应
    if (error.response && error.response.config.responseType === 'arraybuffer') {
      try {
        // 尝试解析错误响应
        const decoder = new TextDecoder('utf-8')
        const text = decoder.decode(error.response.data)
        const jsonData = JSON.parse(text)
        error.response.data = jsonData
      } catch (e) {
        // 如果解析失败，保持原始错误
        console.log('无法解析错误响应为JSON')
      }
    }
    return Promise.reject(error)
  }
)


function get_token() {
  let cookie = document.cookie.split('; ')
  let cookieObject = {}
  for (let i in cookie) {
    let cookieValue = cookie[i].split('=')
    cookieObject[cookieValue[0]] = cookieValue[1]
  }
  return cookieObject['metro-token']
}

function get_new_device_table(params) {
  return axios.post(
    '/data/query_new_device',
    params
  )
}

function get_sub_table(params) {
  return axios.post(
    '/data/query_sub_table',
    params
  )
}


function get_user_info(params) {
  return axios(
    {
      method: "get",
      url: '/data/uid/get_user_info',
      params: params
    }
  )
}


function get_sub_records(params) {
  return axios(
    {
      method: "get",
      url: '/data/uid/get_user_sub_records',
      params: params
    }
  )
}


function get_user_conn_records(params) {
  return axios(
    {
      method: "get",
      url: '/data/uid/get_user_conn_records',
      params: params
    }
  )
}

function get_wish_data_chart(params) {
  return axios(
    {
      method: "get",
      url: '/data/wish/server/chart',
      params: params
    }
  )
}

function get_wish_comments(params) {
  return axios(
    {
      method: "get",
      url: '/data/wish/server/comments',
      params: params
    }
  )
}

function get_user_disc_conn_records(params) {
  return axios(
    {
      method: "get",
      url: '/data/uid/get_user_disc_conn_records',
      params: params
    }
  )
}

function get_user_api_event_records(params) {
  return axios(
    {
      method: "get",
      url: "/data/uid/get_api_event_records",
      params: params
    }
  )
}


function fetch_sub_record_tables(params) {
  return axios(
    {
      method: "get",
      url: '/data/sub_records',
      params: params
    }
  )
}

function fetch_sub_record_tables2(params) {
  return axios(
    {
      method: "get",
      url: '/data/sub_records2',
      params: params
    }
  )
}

function get_sub_user_table(params) {
  return axios(
    {
      method: "get",
      url: '/data/query_sub_user_table',
      params: params
    }
  )
}

function get_sub_user_table2(params) {
  return axios(
    {
      method: "get",
      url: '/data/query_sub_user_table2',
      params: params
    }
  )
}

function get_sub_user_table3(params) {
  return axios(
    {
      method: "get",
      url: '/data/query_sub_user_table3',
      params: params
    }
  )
}


function get_filter_options() {
  return axios.get(
    '/data/config'
  )
}


function get_renew_data_table(params) {
  return axios(
    {
      method: "get",
      url: '/data/sub/renew_table',
      params: params
    }
  )
}


function flush_new_user_info_by_uid(uid_list, project) {
  return axios.post(
    '/data/uid/flush_user_info',
    { uid_list: uid_list, project: project }
  )

}


function get_asa_campaign_tables(params) {
  return axios(
    {
      method: "get",
      url: '/data/asa_table',
      params: params
    }
  )
}

function get_asa_campaign_tables_ljh(params) {
  return axios(
    {
      method: "get",
      url: '/data/asa_table_ljh',
      params: params
    }
  )
}

function get_asa_campaign_tables2(params) {
  return axios(
    {
      method: "get",
      url: '/data/asa_table2',
      params: params
    }
  )
}

function get_asa_campaign_tables3(params) {
  return axios(
    {
      method: "get",
      url: '/data/asa_table3',
      params: params
    }
  )
}

function get_fb_campaign_tables(params) {
  return axios(
    {
      method: "get",
      url: '/data/fb_table',
      params: params
    }
  )
}

function login_service(params) {
  return axios.post(
    '/data/login',
    params
  )
}


function get_income_tables(params) {
  return axios(
    {
      method: "get",
      url: "/data/query_income_table",
      params: params
    }
  )
}

function get_income_tables2(params) {
  return axios(
    {
      method: "get",
      url: "/data/query_income_table2",
      params: params
    }
  )
}

function get_income_tables3(params) {
  return axios(
    {
      method: "get",
      url: "/data/query_income_table3",
      params: params
    }
  )
}

function send_reward(email, gift_time_type, remark) {
  var data = {
    email: email,
    gift_time_type: gift_time_type,
    remark: remark,
    token: 'Lightsail'
  }
  var form_data = b64encode(data)
  return axios(
    {
      method: "post",
      url: "/pay/web/gift_time/generate",
      data: qs.stringify({form_data})
    }
  )
}

function query_reward(gift_time_status, gift_time_type, start_date, end_date) {
  var data = {
    gift_time_status: gift_time_status,
    gift_time_type: gift_time_type,
    start_date: start_date,
    end_date: end_date,
    email: '',
    token: 'Lightsail'
  }
  var form_data = b64encode(data)
  return axios(
    {
      method: "post",
      url: "/pay/web/gift_time/query",
      data: qs.stringify({form_data})
    }
  )
}

function win_back_email_buy(start_date, end_date, activity, sku, pay_source, email) {
    var data = {
        start_date: start_date,
        end_date: end_date,
        activity: activity,
        sku: sku,
        pay_source: pay_source,
        email: email,
        token: 'Lightsail'
    }
    var form_data = b64encode(data)
    return axios(
        {
          method: "post",
          url: "/pay/web/win_back/purchase",
          data: qs.stringify({form_data})
        }
    )
}

function win_back_email_send(start_date, end_date, activity) {
var data = {
        start_date: start_date,
        end_date: end_date,
        activity: activity,
        token: 'Lightsail'
    }
    var form_data = b64encode(data)
    return axios(
        {
          method: "post",
          url: "/pay/web/win_back/email",
          data: qs.stringify({form_data})
        }
    )
}

function email_send_select(start_date, end_date, activity) {
    var params = {
      start_date: start_date,
      end_date: end_date,
      activity: activity,
    }
    return axios(
      {
        method: "get",
        url: "/data/statics/email",
        params: params
      }
  )
}

function export_asa_data_excel(params) {
  return axios({
    method: "post",
    url: "/data/asa_export_excel",
    params: params,
    responseType: 'arraybuffer'
  })
}

function get_wallpaper_category_stats(params) {
  return axios({
    method: "get",
    url: "/data/wallpaper/category_stats",
    params: params
  })
}

function get_wallpaper_item_stats(params) {
  return axios({
    method: "get",
    url: "/data/wallpaper/item_stats",
    params: params
  })
}

function get_wallpaper_device_stats(params) {
  return axios({
    method: "get",
    url: "/data/wallpaper/device_stats",
    params: params
  })
}

function get_wallpaper_config() {
  return axios({
    method: "get",
    url: "/data/wallpaper/config"
  })
}

function get_wallpaper_apply_failed_stats(params) {
  return axios({
    method: "get",
    url: "/data/wallpaper/apply_failed_stats",
    params: params
  })
}

export {
  get_new_device_table,
  get_sub_table,
  get_sub_user_table,
  get_sub_user_table2,
  get_sub_user_table3,
  get_filter_options,
  flush_new_user_info_by_uid,
  get_renew_data_table,
  fetch_sub_record_tables,
  fetch_sub_record_tables2,
  get_asa_campaign_tables,
  get_asa_campaign_tables_ljh,
  get_asa_campaign_tables2,
  get_asa_campaign_tables3,
  get_fb_campaign_tables,
  get_income_tables,
  get_income_tables2,
  get_income_tables3,
  login_service,
  get_token,
  get_user_info,
  get_sub_records,
  get_user_conn_records,
  get_user_disc_conn_records,
  get_user_api_event_records,
  get_wish_data_chart,
  get_wish_comments,
  send_reward,
  query_reward,
  win_back_email_send,
  win_back_email_buy,
  baseUrl,
  email_send_select,
  export_asa_data_excel,
  get_wallpaper_category_stats,
  get_wallpaper_item_stats,
  get_wallpaper_device_stats,
  get_wallpaper_config,
  get_wallpaper_apply_failed_stats
}